import { StatelessComponent } from 'react'
import * as styles from 'components/features/pfm/CreditLinkagePage/CreditLinkagePage.css'
import Anchor from 'components/atoms/navigation/Anchor'
import CreditLinkageContainer from 'components/features/pfm/CreditLinkage/CreditLinkageContainer'
import CreditLinkageCompletion from 'components/molecules/CreditLinkageCompletion'
import CommonFooter from 'components/molecules/CommonFooter'
import InternalLayoutContainer from 'components/features/pfm/InternalLayout/InternalLayoutContainer'
import InternalSidebarContainer from 'components/features/pfm/InternalSidebar/InternalSidebarContainer'
import { NotificationTrayWrapper } from 'components/features/pfm/NotificationTray/NotificationTrayWrapper'

export type CreditLinkagePageStateProps = {
  isCreditFileLinked: boolean
}

type CreditLinkagePageProps = CreditLinkagePageStateProps

export const CreditLinkagePage: StatelessComponent<CreditLinkagePageProps> = (props) => {
  const { isCreditFileLinked } = props

  const linkageContent = !isCreditFileLinked && (
    <section className={ styles.linkage }>
      { /* \u00A0 is nbsp  */ }
      <CreditLinkageContainer title={ `Let's link your credit\u00A0file` } />
    </section>
  )

  const linkedContent = isCreditFileLinked && (
    <section className={ styles.linked }>
      <CreditLinkageCompletion />
    </section>
  )

  const notifications = (
    <NotificationTrayWrapper
      renderLevel='page'
      isPositionRelative
    />
  )

  return (
    <InternalLayoutContainer
      sidebar={ <InternalSidebarContainer /> }
      notifications={ notifications }
    >
      <Anchor placement='credit-linkage'>
        <section className={ styles.creditLinkagePage }>
          <section className={ styles.main }>
            { linkageContent || linkedContent }
          </section>
          <footer className={ styles.footer }>
            <CommonFooter />
          </footer>
        </section>
      </Anchor>
    </InternalLayoutContainer>
  )
}
